module.exports = __webpack_public_path__ + "static/img/wx.f3475029.svg";